import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MappingtypeComponent } from '../../mappingtype/mappingtype.component';
import { CommonPopupSearchComponent } from '../../common-popup-search/common-popup-search.component';
import { forkJoin, map } from 'rxjs';


export interface loadobjectsmstr {
  edata: any;
}
@Component({
    selector: 'app-loadobjectmstr-popup',
    templateUrl: './loadobjectmstr-popup.component.html',
    styleUrls: ['./loadobjectmstr-popup.component.scss'],
    standalone: false
})

export class LoadobjectmstrPopupComponent implements OnInit {


  backgroundColorButton;
  FormValid: FormGroup;
  updatedData;
  uploadId;
  name;
  validation_messages: any;
  mappingtypename
  buttonName
  idColumn
  formValidCheckbox: UntypedFormGroup;
  isCheckboxSelected = false;
  showCreateAnother = true;
  objectGroupData: any = []
  selectedGroup: any
  selfReferenceFileList: {
  fileName: string;
  mappingconfigurationid: number;
}[] = [];
circularReferenceFileList: {
  fileName: string;
  mappingconfigurationid: number;
}[] = [];
  selfreferencefields: any =[];

  fileNameList: any[] = [];
  isSelfRefPopupOpen = false;
  isCircularRefPopupOpen = false;


  loadObjects = {
    'LoadObjectsMstrId': '', 'objectName': '', 'loadOrder': '', 'tenantid': '', 'isloadable': false, 'isParent': false, 'level': null as number | null, 'deferred': false,
    'vaultExtraction': '', 'vqlCriteria': '', 'requiresGlobalObject': false, 'objectType': '', 'fileName': '', 'deletionLevel': '',
    'loadAction': '', 'parentObjectNameForExtraction': '', 'sourceDataExtractionVql': '', 'objectgroupname': '', 'selfreferenceobject': [] as string[],
    'selfreferencefields': '', 'circularreferenceobject': [] as string[], 'circularreferencefields': '', 'migrationmode':'','mappingconfigurationid': null
  }

  /*
  Author- Renuka chama
  04/02/2026
  For creation of  loadobjectmstr popup screen
*/


  constructor(private commonservice: CommonService, public dialogRef: MatDialogRef<MappingtypeComponent>, private validation: validationmethod, private localstorage: LocalStorageSettingsService,
    private errormessage: ErrorMessages, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: loadobjectsmstr, private fb: UntypedFormBuilder,
    private dialog: MatDialog,
  ) {
    this.validation_messages = this.errormessage.loadobjects;
  }

  ngOnInit(): void {

    const workSpaceId = this.localstorage.getSettings("WorkspaceId")
    console.log(workSpaceId)

    const dnsId = this.localstorage.getSettings("dnsName")
    this.buttonName = 'Save'
    console.log(this.data.edata)
    this.formvalidations();
    this.updatedData = this.data.edata
    if (this.updatedData.LoadObjectsMstrId != null) {
      this.buttonName = 'Update'
      this.showCreateAnother = false;

      this.FormValid.patchValue({
  isloadable: this.updatedData.isloadable === 'true',
  isParent: this.updatedData.isParent === 'true',
  deferred: this.updatedData.deferred === 'true',
  requiresGlobalObject: this.updatedData.requiresGlobalObject === 'true'
});

      this.loadObjects.LoadObjectsMstrId = this.updatedData.LoadObjectsMstrId
      this.loadObjects.objectName = this.updatedData.objectName
      this.loadObjects.loadOrder = this.updatedData.loadOrder
      this.loadObjects.isloadable = this.updatedData.isloadable === 'true'
      this.loadObjects.isParent = this.updatedData.isParent === 'true'
      this.loadObjects.level = this.updatedData.level
     
      this.loadObjects.deferred = this.updatedData.deferred === 'true'
      this.loadObjects.vaultExtraction = this.updatedData.vaultExtraction
      this.loadObjects.vqlCriteria = this.updatedData.vqlCriteria
      this.loadObjects.requiresGlobalObject = this.updatedData.requiresGlobalObject === 'true'
      this.loadObjects.objectType = this.updatedData.objectType
      this.loadObjects.fileName = this.updatedData.fileName
      this.FormValid.patchValue({
  fileName: this.updatedData.fileName
});
      this.loadObjects.deletionLevel = this.updatedData.deletionLevel
      this.loadObjects.loadAction = this.updatedData.loadAction
      this.loadObjects.parentObjectNameForExtraction = this.updatedData.parentObjectNameForExtraction
      this.loadObjects.sourceDataExtractionVql = this.updatedData.sourceDataExtractionVql
      this.loadObjects.objectgroupname = this.updatedData.objectgroupname
      if (this.updatedData?.selfreferenceobject) {
  this.loadObjects.selfreferenceobject = this.updatedData.selfreferenceobject.split(',');
}
      this.loadObjects.selfreferencefields = this.updatedData.selfreferencefields
      if (this.updatedData?.circularreferenceobject) {
  this.loadObjects.circularreferenceobject = this.updatedData.circularreferenceobject.split(',');
}
      this.loadObjects.circularreferencefields = this.updatedData.circularreferencefields
      this.loadObjects.migrationmode = this.updatedData.migrationmode
      

       this.FormValid.patchValue({
  level: Number(this.updatedData.level)
});

this.onLevelChange(this.updatedData.level);

  this.FormValid.get('level')?.valueChanges.subscribe(level => {
  if (level !== null && level !== undefined) {
    this.onLevelChange(level);
  } else {
    this.selfReferenceFileList = [];
    this.circularReferenceFileList = [];
  }
});


 if (this.updatedData?.selfreferencefields ) {
  try {
    const parsed = JSON.parse(this.updatedData.selfreferencefields);

    const displayValue = parsed
      .map(j => `${j.filename}.${j.fields}`)
      .join(', ');

    this.FormValid.patchValue({
      selfreferencefields: displayValue
    });

    this.loadObjects.selfreferencefields = this.updatedData.selfreferencefields;
  } catch (e) {
    console.error('Invalid selfreferencefields JSON', e);
  }
}


 if (this.updatedData?.circularreferencefields ) {
  try {
    const parsed = JSON.parse(this.updatedData.circularreferencefields);

    const displayValue = parsed
      .map(j => `${j.filename}.${j.fields}`)
      .join(', ');

    this.FormValid.patchValue({
      circularreferencefields: displayValue
    });

    this.loadObjects.circularreferencefields = this.updatedData.circularreferencefields;
  } catch (e) {
    console.error('Invalid circularreferencefields JSON', e);
  }
}


    }

    this.loadFileNameDropdown();
    console.log(this.data)
    this.backgroundColorButton = this.localstorage.getSettings('ColorA');


    this.formValidationsCheckbox();

  }
  cancel() {
    this.dialogRef.close();
  }

  formValidationsCheckbox() {
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl(false)
    });
  }

  formvalidations() {
    this.FormValid = new FormGroup({
      'objectName': new FormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      'loadOrder': new FormControl('', [Validators.required, this.validation.noWhitespaceValidator, Validators.pattern('^[1-9][0-9]*$')]),
      'isloadable': new FormControl(''),
      'isParent': new FormControl(''),
      'level': new FormControl('', [Validators.required, Validators.pattern('^[0-9][0-9]*$')]),
      'deferred': new FormControl(''),
      'vaultExtraction': new FormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      'vqlCriteria': new FormControl(''),
      'requiresGlobalObject': new FormControl(''),
      'objectType': new FormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      'fileName': new FormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      'deletionLevel': new FormControl(''),
      'loadAction': new FormControl(''),
      'parentObjectNameForExtraction': new FormControl(''),
      'sourceDataExtractionVql': new FormControl(''),
      'objectgroupname': new FormControl(''),
      'migrationmode' : new FormControl(''),
      'selfreferenceobject' : new FormControl([]),
      'selfreferencefields' : new FormControl([]),
      'circularreferenceobject' : new FormControl([]),
      'circularreferencefields' : new FormControl([])

    })
  }


onIsLoadableChange(e: any) {
  this.loadObjects.isloadable = e.checked;
}

onIsParentChange(e: any) {
  this.loadObjects.isParent = e.checked;
}

onDeferredChange(e: any) {
  this.loadObjects.deferred = e.checked;
}

onGlobalObjectChange(e: any) {
  this.loadObjects.requiresGlobalObject = e.checked;
}

private resolveMappingIdFromFileName(fileName: string) {
  if (!fileName || !this.fileNameList?.length) return null;

  const match = this.fileNameList.find(
    f => f.fileName === fileName
  );

  return match ? match.mappingconfigurationid : null;
}

private getMappingIdFromSelfRefFile(fileName: string): number | null {
  const match = this.selfReferenceFileList.find(
    f => f.fileName === fileName
  );
  return match ? match.mappingconfigurationid : null;
}
private getMappingIdFromCircularRefFile(fileName: string): number | null {
  const match = this.circularReferenceFileList.find(
    f => f.fileName === fileName
  );
  return match ? match.mappingconfigurationid : null;
}

loadFileNameDropdown() {
  this.commonservice.retrieveMappingConfiguration().subscribe((response: any) => {
    if (response.error === true) {
      return;
    }

    const list = response || [];

  this.fileNameList = (response || []).map(obj => ({
      displayName: `${obj.stageobject}_${obj.targetobject}`,
      fileName: `${obj.stageobject}_${obj.targetobject}`,
      mappingconfigurationid: obj.mappingconfigurationid
    }));

  if (this.updatedData?.fileName) {
      this.FormValid.patchValue({
        fileName: this.updatedData.fileName
      });

      this.onFileNameChange(this.updatedData.fileName);



  if (this.updatedData?.LoadObjectsMstrId) {
        this.loadObjects.fileName = this.updatedData.fileName;
      }
    }
  });
}

onFileNameChange(fileName: string) {

  this.loadObjects.fileName = fileName;

  const selectedObj = this.fileNameList.find(
    x => x.fileName === fileName
  );

  this.loadObjects.mappingconfigurationid =
    selectedObj ? selectedObj.mappingconfigurationid : null;
}


private getSelfRefSelectedRows() {
  if (!this.loadObjects.selfreferencefields) return [];

  try {
    const parsed = JSON.parse(this.loadObjects.selfreferencefields);
    return parsed.map(j => j.fields);
  } catch {
    return [];
  }
}



openSelfReferenceFieldsPopup() {
  if (this.isSelfRefPopupOpen) return;

  const selectedFiles: string[] =
    this.FormValid.get('selfreferenceobject')?.value || [];

  if (!selectedFiles.length) {
    this.snackbar.open(
      'Please select Self Reference Object first',
      'OK',
      { duration: 3000 }
    );
    return;
  }

  const invalidFiles = selectedFiles.filter(
    f => !this.getMappingIdFromSelfRefFile(f)
  );

  if (invalidFiles.length) {
    this.snackbar.open(
      'Invalid Self Reference File selected. Please reselect.',
      'OK',
      { duration: 3000 }
    );
    return;
  }

  this.isSelfRefPopupOpen = true;
  this.spinner.start();

  const apiCalls = selectedFiles.map(fileName =>
    this.commonservice
      .getTargetAttributesByMappingConfigId(
        this.getMappingIdFromSelfRefFile(fileName)!
      )
      .pipe(
        map(attrs =>
          attrs.map(attr => ({
            filename: fileName,
            field: attr.name
          }))
        )
      )
  );

  forkJoin(apiCalls).subscribe({
    next: results => {
      const edata = results.flat();

      if (!edata.length) {
        this.snackbar.open('No attributes found', 'OK', { duration: 3000 });
        return;
      }

      const dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: '60%',
        autoFocus: false,
        disableClose: true,
        data: {
          edata,
          page: 'multiple',
          columns: [
            { filename: 'Filename', field: 'Field' }
          ],
          selectedValue: this.getSelfRefSelectedRows(),
          selectedPropertyName: 'field'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) return;

        const jsonResult = result.selectedRows.map(row => ({
          filename: row.filename,
          fields: row.field
        }));

        this.FormValid.patchValue({
          selfreferencefields: jsonResult
            .map(j => `${j.filename}.${j.fields}`)
            .join(', ')
        });

        this.loadObjects.selfreferencefields =
          JSON.stringify(jsonResult);
      });
    },
    error: () => {
      this.snackbar.open(
        'Failed to load self reference attributes',
        'OK',
        { duration: 3000 }
      );
    },
    complete: () => {
      this.spinner.stop();
      this.isSelfRefPopupOpen = false;
    }
  });
}


openCircularReferenceFieldsPopup() {
  if (this.isCircularRefPopupOpen) return;

  const selectedFiles: string[] =
    this.FormValid.get('circularreferenceobject')?.value || [];

  if (!selectedFiles.length) {
    this.snackbar.open(
      'Please select Circular Reference Object first',
      'OK',
      { duration: 3000 }
    );
    return;
  }

    const invalidFiles = selectedFiles.filter(
    f => !this.getMappingIdFromCircularRefFile(f)
  );

  if (invalidFiles.length) {
    this.snackbar.open(
      'Invalid Circular Reference File selected. Please reselect.',
      'OK',
      { duration: 3000 }
    );
    return;
  }

  this.isCircularRefPopupOpen = true;
  this.spinner.start();

  const apiCalls = selectedFiles.map(fileName =>
  this.commonservice
    .getTargetAttributesByMappingConfigId(
      this.getMappingIdFromCircularRefFile(fileName)!
    )
    .pipe(
      map(attrs =>
        attrs.map(attr => ({
          filename: fileName,
          field: attr.name
        }))
      )
    )
);

forkJoin(apiCalls).subscribe({
    next: results => {
      const edata = results.flat();

      if (!edata.length) {
        this.snackbar.open('No attributes found', 'OK', { duration: 3000 });
        return;
      }

        const dialogRef = this.dialog.open(CommonPopupSearchComponent, {
          width: '60%',
          autoFocus: false,
          disableClose: true,
          data: {
            edata,
            page: 'multiple',
            columns: [
              { filename: 'Filename', field: 'Field' }
            ],
            selectedValue: this.getCircularRefSelectedRows(),
            selectedPropertyName: 'field'
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (!result) return;

          const jsonResult = result.selectedRows.map(row => ({
            filename: row.filename,
            fields: row.field
          }));

          this.FormValid.patchValue({
            circularreferencefields: jsonResult
              .map(j => `${j.filename}.${j.fields}`)
              .join(', ')
          });

          this.loadObjects.circularreferencefields =
            JSON.stringify(jsonResult);
        });
      },
      error: () => {
        this.snackbar.open(
          'Failed to load circular reference attributes',
          'OK',
          { duration: 3000 }
        );
        
      },
      complete: () => {
        this.spinner.stop();
        this.isCircularRefPopupOpen = false;
      }
    });
}


private getCircularRefSelectedRows() {
  if (!this.loadObjects.circularreferencefields) return [];

  try {
    const parsed = JSON.parse(this.loadObjects.circularreferencefields);
    return parsed.map(j => j.fields);
  } catch {
    return [];
  }
}



onLevelChange(levelValue?: any) {
  const level = Number(levelValue ?? this.FormValid.get('level')?.value);
  const tenantId = Number(this.localstorage.getSettings('dnsName'));

  const selfRefCtrl = this.FormValid.get('selfreferenceobject');
  const circularRefCtrl = this.FormValid.get('circularreferenceobject');

 if (isNaN(level) || level < 0) {
    this.selfReferenceFileList = [];
    this.circularReferenceFileList = [];
    selfRefCtrl?.disable();
    circularRefCtrl?.disable();
    return;
  }
 selfRefCtrl?.enable();
  circularRefCtrl?.enable();

  this.commonservice
    .getSelfReferenceFiles(tenantId, level)
    .subscribe(res => {
      this.selfReferenceFileList = res || [];
      this.circularReferenceFileList = res || [];
      if (this.updatedData?.selfreferenceobject) {
        this.FormValid.patchValue({
          selfreferenceobject: this.updatedData.selfreferenceobject.split(',')
        });
        this.loadObjects.selfreferenceobject =
          this.updatedData.selfreferenceobject.split(',');
      }

      if (this.updatedData?.circularreferenceobject) {
        this.FormValid.patchValue({
          circularreferenceobject: this.updatedData.circularreferenceobject.split(',')
        });
        this.loadObjects.circularreferenceobject =
          this.updatedData.circularreferenceobject.split(',');
      }
    });
}






  saveMethod() {
    if (!this.FormValid.valid) {
      this.FormValid.markAllAsTouched();
      this.snackbar.open("All mandatory fields to be filled", "ok", { duration: 3000 });
      return
    }

if (this.loadObjects.fileName) {
  const selectedObj = this.fileNameList.find(
    x => x.fileName === this.loadObjects.fileName
  );

  if (selectedObj) {
    this.loadObjects.mappingconfigurationid =
      selectedObj.mappingconfigurationid;
  } else {
    this.loadObjects.mappingconfigurationid = null;
  }
}

    var dnsid = localStorage.getItem('dnsName');
    if (this.buttonName == 'Update') {
      this.idColumn = this.loadObjects.LoadObjectsMstrId;
    } else {
      this.idColumn = 0;
    }

    const selfRefs = this.FormValid.get('selfreferenceobject')?.value || [];
  const circularRefs = this.FormValid.get('circularreferenceobject')?.value || [];

    const requestData = {
      objectName: this.loadObjects.objectName,
      tenantid: dnsid,
      LoadObjectsMstrId: this.idColumn,
      loadOrder: this.loadObjects.loadOrder,
      isloadable: String(this.loadObjects.isloadable),
      isParent: String(this.loadObjects.isParent),
      level: Number(this.FormValid.get('level')?.value),
      deferred: String(this.loadObjects.deferred),
      vaultExtraction: this.loadObjects.vaultExtraction,
      vqlCriteria: this.loadObjects.vqlCriteria,
      requiresGlobalObject: String(this.loadObjects.requiresGlobalObject),
      objectgroupname: this.loadObjects.objectgroupname,
      objectType: this.loadObjects.objectType,
      fileName: this.loadObjects.fileName,
      deletionLevel: this.loadObjects.deletionLevel,
      loadAction: this.loadObjects.loadAction,
      parentObjectNameForExtraction: this.loadObjects.parentObjectNameForExtraction,
      sourceDataExtractionVql: this.loadObjects.sourceDataExtractionVql,
      migrationmode: this.loadObjects.migrationmode,

    selfreferenceobject: selfRefs.length
    ? selfRefs.map(v => v.trim()).join(',')
    : null,

  circularreferenceobject: circularRefs.length
    ? circularRefs.map(v => v.trim()).join(',')
    : null,
    selfreferencefields: this.loadObjects.selfreferencefields,
    circularreferencefields:this.loadObjects.circularreferencefields,
    mappingconfigurationid: this.loadObjects.mappingconfigurationid,



    };
    if (!this.loadObjects.mappingconfigurationid) {
  this.snackbar.open(
    'Invalid File Name. Please reselect File Name.',
    'OK',
    { duration: 3000 }
  );
  return;
}

    this.spinner.start();
    this.commonservice.saveLoadObjectsMstr(requestData).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          this.spinner.stop();
          return
        }
        console.log('edit successful', response);
        console.log(response.data)
        this.updatedData = null;
        this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
        if (this.isCheckboxSelected && this.buttonName === 'Save') {
          this.FormValid.reset();
          this.loadObjects.objectName = '',
            this.loadObjects.loadOrder = '',
            this.loadObjects.LoadObjectsMstrId = '',
            this.loadObjects.isloadable = false,
            this.loadObjects.isParent = false,
            this.FormValid.get('level')?.reset(),
            this.loadObjects.deferred = false,
            this.loadObjects.vaultExtraction = '',
            this.loadObjects.vqlCriteria = '',
            this.loadObjects.requiresGlobalObject = false,
            this.loadObjects.objectgroupname = '',
            this.loadObjects.objectType = '',
            this.loadObjects.fileName = '',
            this.loadObjects.deletionLevel = '',
            this.loadObjects.loadAction = '',
            this.loadObjects.parentObjectNameForExtraction = '',
            this.loadObjects.sourceDataExtractionVql = '',
            this.loadObjects.parentObjectNameForExtraction = '',
            this.loadObjects.migrationmode =''

            this.buttonName = 'Save';
        } else {
          this.dialogRef.close(response.data);
        }
      },
      error: (error: any) => {
        console.error('retrieve failed', error);
        this.spinner.stop();
      },
      complete: () => {
        console.log('retrieve  completed');
        this.updatedData = null
        this.spinner.stop();
      }
    });
  }
}






